import React, { useState } from "react";

import { createSafeContext } from "../../hooks/useSafeContext";

interface IFloatingBarState {
	shrinkLevel: number;
}

interface IFloatingBarActions {
	setShrinkLevel(shrinkLevel: number): void;
}

type FloatingBarContextValue = [Readonly<IFloatingBarState>, IFloatingBarActions];

const [useFloatingBar, FloatingBarContextProvider] = createSafeContext<FloatingBarContextValue>(
	"useFloatingBar requires a parent <FloatingBar.Root>.",
);

export { useFloatingBar };

export function FloatingBarProvider({ children }: React.PropsWithChildren) {
	const [shrinkLevel, setShrinkLevel] = useState(0);

	const floatingBarValue: FloatingBarContextValue = [
		{ shrinkLevel },
		{
			setShrinkLevel,
		},
	];

	return (
		<FloatingBarContextProvider value={floatingBarValue}>{children}</FloatingBarContextProvider>
	);
}
